module.exports = __webpack_public_path__ + "../assets/img/d9c1f4eeaa734f269c313d42a0e15915.svg";